if(!global._babelPolyfill) {
    require("babel-polyfill");
}

import Vue from 'vue';
import CookieJS from 'js-cookie';
import SkovAPI from './skovapi.js';
import PageSearchWidget from './components/page-search-widget.vue';
import PagePriceoverviewWidget from './components/page-price-overview-widget.vue';
import VMasker from './MaskedInput.js';

Vue.directive('ui-mask', (el, binding) => {
    if(binding.value.mask) {
        VMasker(el).maskPattern(binding.value.mask);
    }
});

window.MENU_COMPONENT= new Vue({
    el: '#menu',
    data() {
        return {
            open: false,
            user: null
        };
    },
    created() {
        this.checkUserLogin();
        this.$on('userlogin', this.checkUserLogin);
        this.$on('userlogout', this.checkUserLogin);
    },
    beforeDestroy() {
        window.removeEventListener('click', this.closeMenuOnPageClick);
    },
    methods: {
        checkUserLogin() {
            let token = CookieJS.get(APP_CONFIG.AUTH_COOKIE_NAME);
            if(token && !this.user) {
                SkovAPI.setToken(token);
                SkovAPI.getUser().then((res) => {
                    this.user = res.data; 
                });
            } else {
                this.user = null;
            }
        },
        goToMySkov() {
            this.open = false;
            window.location = '/#/myskov/offers';
        },
        closeMenuOnPageClick(evt) {
            const mainNavList = this.$refs.main_nav_list;
            if(this.open && mainNavList && !mainNavList.contains(evt.target)) {
                this.open = false;
            }
        }
    },
    watch: {
        open() {
            if(this.open) {
                document.getElementsByTagName('body')[0].classList.add('showMenu');
                window.addEventListener('click', this.closeMenuOnPageClick);
            } else {
                document.getElementsByTagName('body')[0].classList.remove('showMenu');
                window.removeEventListener('click', this.closeMenuOnPageClick);
            }
        }
    }
});

if(document.getElementById('page-search-widget')) {
    console.log('Found page search widget!');
    const VuePageSearchWidget = new Vue({
        el: '#page-search-widget',
        components: {
            PageSearchWidget
        }
    });
}

if(document.getElementById('page-priceoverview-widget')) {
    console.log('Found page search widget!');
    const VuePRiceOverviewWidget = new Vue({
        el: '#page-priceoverview-widget',
        components: {
            PagePriceoverviewWidget
        }
    });
}